<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense flat color="secondary">
        <v-toolbar-title>Purchase Preview</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small text to="/goods-receipt">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-row>
          <v-col cols="12" md="12">
            <!-- <v-btn text @click="generateInvoice" color="primary">
              <v-icon color="black" left>mdi-file-pdf-box</v-icon>Generate
              Invoice
            </v-btn>-->
          </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-row class="subtitle-2 text--primary">
          <v-col cols="12" md="4">
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>Invoice#:</td>
                    <td>{{ Invoice && Invoice.DocNum }}</td>
                  </tr>
                  <tr>
                    <td>Client:</td>
                    <td>{{ Invoice.Supplier && Invoice.Supplier.Name }}</td>
                  </tr>
                  <tr>
                    <td>Total Bill:</td>
                    <td>{{ Invoice && Invoice.DocTotal | currency }}</td>
                  </tr>
                  <tr>
                    <td>Total Paid:</td>
                    <td>{{ Invoice && TotalPaid | currency }}</td>
                  </tr>
                  <tr>
                    <td>Balance:</td>
                    <td>{{ Invoice && Balance | currency }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <v-col cols="12" offset-md="4" md="4">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Account</th>
                    <th class="text-left">Amount Paid</th>
                    <th class="text-left">Ref No</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in Payments" v-bind:key="index">
                    <td>{{ item.Account && item.Account.Name }}</td>
                    <td>{{ item.Amount | currency }}</td>
                    <td>{{ item.PaymentRemarks }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-row dense id="po" class="text--primary subtitle-2 mt-2">
          <v-col cols="12">
            <v-data-table light :mobile-breakpoint="0" :items-per-page="pageItems" :headers="headers" :items="Rows"
              item-key="id" hide-default-footer>
              <template v-slot:item.Name="{ item }">
                <span style="width: 200px">{{ item.product && item.product.Name }}</span>
              </template>

              <template v-slot:item.Quantity="{ item }">
                {{
                  item.Quantity
                }}
              </template>

              <template v-slot:item.Price="{ item }">
                <span v-if="item.Price">{{ item.Price | currency }}</span>
              </template>

              <template v-slot:item.DiscSum="{ item }">
                {{
                  item.DiscSum
                }}
              </template>

              <template v-slot:item.LineTotal="{ item }">
                {{
                  item.LineTotal | currency
                }}
              </template>

              <template v-slot:item.imei="{ item }">
                <v-btn text :to="`/device-imeis/${item.id}`" color="accent">
                  <v-icon left>mdi-view-list</v-icon> IMEI LIST
                </v-btn>
              </template>

              <template v-slot:item.rejects="{ item }">
                <v-chip small :color="item.RejectQty > 0 ? 'error' : 'default'" class="mr-2">
                  {{ item.RejectQty || 0 }}
                </v-chip>
                <v-btn x-small color="primary" @click="openRejectDialog(item)">
                  <v-icon small left>mdi-alert-circle</v-icon>
                  {{ item.RejectQty > 0 ? 'Edit' : 'Add Rejects' }}
                </v-btn>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <!-- snackbar -->
        <snackbar ref="snackbar"></snackbar>
      </v-card-text>
    </v-card>

    <!-- Reject Dialog -->
    <v-dialog v-model="rejectDialog" max-width="600px" persistent>
      <v-card>
        <v-toolbar dense flat color="error">
          <v-toolbar-title class="white--text">
            <v-icon left dark>mdi-alert-circle</v-icon>
            Add/Edit Rejects
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeRejectDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pt-4">
          <v-form ref="rejectFormRef" v-if="selectedRow">
            <v-row>
              <v-col cols="12">
                <v-alert type="info" dense text>
                  <strong>Product:</strong> {{ selectedRow.product && selectedRow.product.Name }}<br>
                  <strong>Received Quantity:</strong> {{ selectedRow.Quantity }}<br>
                  <strong>Current Rejects:</strong> {{ selectedRow.RejectQty || 0 }}
                </v-alert>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model.number="rejectForm.quantity"
                  label="Reject Quantity"
                  type="number"
                  outlined
                  dense
                  :rules="[
                    v => v >= 0 || 'Quantity must be positive',
                    v => v <= selectedRow.Quantity || 'Cannot exceed received quantity'
                  ]"
                  hint="Enter the quantity to reject"
                  persistent-hint
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="2" class="d-flex align-center">
                <span class="subtitle-1 font-weight-bold">{{ getUomName() }}</span>
              </v-col>

              <v-col cols="12">
                <v-textarea
                  v-model="rejectForm.reason"
                  label="Reason for Rejection"
                  outlined
                  dense
                  rows="3"
                  :rules="[v => !!v || 'Reason is required']"
                  hint="Describe why these items are being rejected"
                  persistent-hint
                ></v-textarea>
              </v-col>

              <v-col cols="12">
                <v-alert type="warning" dense text v-if="rejectForm.quantity > 0">
                  <strong>Impact:</strong><br>
                  - New Line Total: {{ calculatedLineTotal | currency }}<br>
                  - Rejected Amount: {{ rejectedAmount | currency }}
                </v-alert>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeRejectDialog">Cancel</v-btn>
          <v-btn color="error" @click="saveRejects" :loading="loader">
            <v-icon left>mdi-content-save</v-icon>
            Save Rejects
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- pdf preview -->
    <pdf-preview ref="pdfPreview"></pdf-preview>
    <!-- end -->
  </v-container>
</template>


<script>
export default {
  data: () => ({
    record: {},
    loader: false,
    pageItems: 100,
    Invoice: {},
    TotalPaid: 0,
    Balance: 0,
    OutsourcedProducts: [],
    Rows: [],
    Payments: [],
    headers: [
      { text: "Product", value: "Name" },
      { text: "Qty", value: "Quantity" },
      { text: "Unit", value: "uom.UomName" },
      { text: "Price", value: "Price" },
      { text: "Total", value: "LineTotal" },
      { text: "Imei", value: "imei" },
      { text: "Rejects", value: "rejects" }
    ],
    rejectDialog: false,
    selectedRow: null,
    rejectForm: {
      quantity: 0,
      uom: null,
      reason: ''
    }
  }),
  computed: {
    storeName() {
      return localStorage.getItem("storeName");
    },
    calculatedLineTotal() {
      if (!this.selectedRow || !this.rejectForm.quantity) return this.selectedRow?.LineTotal || 0;

      const baseQty = this.getBaseQuantity(this.rejectForm.quantity, this.rejectForm.uom);
      const unitPrice = this.selectedRow.Price / (this.selectedRow.BaseQty || 1);
      const rejectedValue = baseQty * unitPrice;

      return (this.selectedRow.LineTotal || 0) - rejectedValue;
    },
    rejectedAmount() {
      if (!this.selectedRow || !this.rejectForm.quantity) return 0;

      const baseQty = this.getBaseQuantity(this.rejectForm.quantity, this.rejectForm.uom);
      const unitPrice = this.selectedRow.Price / (this.selectedRow.BaseQty || 1);

      return baseQty * unitPrice;
    }
  },
  watch: {
    "$route.params.id": {
      handler: "getById",
      immediate: true
    }
  },
  methods: {
    getById(val) {
      const self = this;
      this.$store
        .dispatch("get", `/purchase-invoice/${val}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.Invoice = res.ResponseData.Invoice;
            self.TotalPaid = res.ResponseData.TotalPaid;
            self.Balance = res.ResponseData.Balance;
            self.Rows = res.ResponseData.PurchaseRows;
            self.Payments = res.ResponseData.Payments;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    openRejectDialog(row) {
      this.selectedRow = row;
      this.rejectForm.quantity = row.RejectQty || 0;
      this.rejectForm.uom = row.UomEntry;
      this.rejectForm.reason = row.RejectReason || '';
      this.rejectDialog = true;
    },
    getUomName() {
      if (!this.selectedRow) {
        return 'Unit(s)';
      }

      // First try to get from the row's uom object
      if (this.selectedRow.uom && this.selectedRow.uom.UomName) {
        return this.selectedRow.uom.UomName;
      }

      // Fallback to searching in product UOM list
      if (this.selectedRow.product && this.selectedRow.product.ugp1 && this.selectedRow.UomEntry) {
        const uom = this.selectedRow.product.ugp1.find(u => u.UomId === this.selectedRow.UomEntry);
        if (uom) {
          return uom.UomName;
        }
      }

      return 'Unit(s)';
    },
    closeRejectDialog() {
      this.rejectDialog = false;
      this.selectedRow = null;
      this.rejectForm = {
        quantity: 0,
        uom: null,
        reason: ''
      };
      if (this.$refs.rejectFormRef) {
        this.$refs.rejectFormRef.resetValidation();
      }
    },
    getBaseQuantity(qty, uomId) {
      if (!this.selectedRow || !this.selectedRow.product || !this.selectedRow.product.ugp1) {
        return qty;
      }

      const uom = this.selectedRow.product.ugp1.find(u => u.UomId === uomId);
      return uom ? qty * uom.BaseQty : qty;
    },
    saveRejects() {
      if (!this.$refs.rejectFormRef.validate()) {
        return;
      }

      this.loader = true;

      const payload = {
        purchaseRowId: this.selectedRow.id,
        rejectQty: this.rejectForm.quantity,
        uomEntry: this.rejectForm.uom,
        rejectReason: this.rejectForm.reason,
        invoiceId: this.Invoice.id,
        rejectedAmount: this.rejectedAmount
      };

      // rejected logic

      // some changes other
      
      // some changes

      // payload changes --- IGNORE ---


      this.$store
        .dispatch("post", {
          url: `/purchase-invoice-rejects`,
          data: payload
        })
        .then(res => {
          this.loader = false;
          if (res.ResultCode == 1200) {
            this.$refs.snackbar.show("Rejects saved successfully", "success");

           // Update local state
            const rowIndex = this.Rows.findIndex(r => r.id === this.selectedRow.id);
            if (rowIndex !== -1) {
              this.$set(this.Rows[rowIndex], 'RejectQty', this.rejectForm.quantity);
              this.$set(this.Rows[rowIndex], 'RejectReason', this.rejectForm.reason);

              // Recalculate line total
              const baseQty = this.getBaseQuantity(this.rejectForm.quantity, this.rejectForm.uom);
              const unitPrice = this.selectedRow.Price / (this.selectedRow.BaseQty || 1);
              const rejectedValue = baseQty * unitPrice;
              this.$set(this.Rows[rowIndex], 'LineTotal', (this.selectedRow.LineTotal || 0) - rejectedValue);
            }

            // Refresh invoice data
            this.getById(this.$route.params.id);
            this.closeRejectDialog();
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
                this.loader = false;
          }
        })
        .catch(err => {
          this.loader = false;
          this.$refs.snackbar.show(err.message || "Error saving rejects", "red");
        });
    },
    generateReceipt() { },
    generateInvoice() { },
    generateDelivery() { },
    setDate(date) {
      this.record.DocDate = date;
    }
  },
  created() { }
};
</script>

<style scoped>
/* .v-text-field__details {
  display: none !important;
} */
</style>